import { useContext } from "react"
import GlobalContext from "../../../../../../context/global-context"
import { useQueryGetAdministrationDashboard } from "../../../../../../queries/useDashboard"
import { formatCurrency } from "../../../../../utils/formatter"
import CardInfo from "./CardInfo"

const AdministrationDashboard = ({ year, highlighnedIndex, customCards, customLoading }) => {
  const { currentBusiness } = useContext(GlobalContext)
  const businessId = currentBusiness?.id || 0
  const { data: dashboardData, isLoading } = useQueryGetAdministrationDashboard(
    businessId,
    { year }
  )

  const dataBancos = [
    { title: 'Por cobrar (incluye IVA)', amount: formatCurrency(dashboardData?.amountToReceive) },
    { title: 'Por pagar (incluye IVA)', amount: formatCurrency(dashboardData?.amountToPay) },
  ];

  const cards = customCards ?? dataBancos.map(item => ({ ...item, highlighned: highlighnedIndex === item.originalIndex }))
  const loading = customLoading ?? isLoading
  const columnsClass = cards.length === 2
    ? 'sm:grid-cols-2 md:grid-cols-2 sm:max-w-[860px] sm:mx-auto'
    : 'sm:grid-cols-3 md:grid-cols-3'

  return (
    <div className={`grid grid-cols-1 ${columnsClass} gap-4 w-full`}>
      {cards.map((item, index) => (
        <CardInfo
          key={index}
          title={item.title}
          amount={item.amount}
          highlighned={item.highlighned}
          isLoading={loading}
        />
      ))}
    </div>
  )
}

export default AdministrationDashboard
